import React from 'react';
import { Link } from '../Link.jsx';
import { getOrgSlug } from '../../lib/utils.js';
import { replaceRoute } from '../../lib/router.js';
import { isEmpty, pickBy } from 'lodash';

export const ProjectReportsLink = ({ ...props }) => (
  <Link route="project-reports" params={{ slug: getOrgSlug() }} {...props} />
);

export const ChangeImpactReportsLink = ({ ...props }) => (
  <Link
    route="change-impact-reports"
    params={{ slug: getOrgSlug() }}
    {...props}
  />
);

export const navigateToProjectReports = (query) => {
  const existingParams = window.location.pathname.includes('/project-reports')
    ? Object.fromEntries(new URLSearchParams(window.location.search))
    : {};

  const params = pickBy(
    {
      ...existingParams,
      ...query,
    },
    (value) => {
      if (value === false || value === 0) return true;
      return !isEmpty(value);
    }
  );
  replaceRoute('project-reports', params);
};

export const navigateToChangeImpactReports = (query) => {
  const existingParams = window.location.pathname.includes(
    '/change-impact-reports'
  )
    ? Object.fromEntries(new URLSearchParams(window.location.search))
    : {};

  const params = pickBy(
    {
      ...existingParams,
      ...query,
    },
    (value) => {
      if (value === false || value === 0) return true;
      return !isEmpty(value);
    }
  );
  replaceRoute('change-impact-reports', params);
};
